import { Injectable } from '@angular/core';
import { User } from '../../class/user';
import { BehaviorSubject, Observable } from 'rxjs';

import { LoginService } from '../login/login.service';
import { MessagesService } from '../messages/messages.service';
import { messages } from '../../app.config';

import { Plugins } from '@capacitor/core';
const { Storage } = Plugins;

@Injectable({
  providedIn: 'root'
})
export class AuthService{

  private currentUserSubject: BehaviorSubject<any>;
  public currentUser: Observable<any>;


  constructor(private loginService:LoginService, private messagesService:MessagesService) {
    // this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
    this.getObject('currentUser').then((data)=>{
      this.currentUserSubject = new BehaviorSubject<any>(data);
      this.currentUser = this.currentUserSubject.asObservable();
    });
  }

  async currentUserValue() {
    return await this.currentUserSubject.value;
  }

  async logout() {
    // localStorage.removeItem('currentUser');
    await Storage.clear();
    this.currentUserSubject.next(null);
    await this.loginService.logout();
  }

  //Stitch
  async login(params:any):Promise<any> {
    return await this.loginService.login(params).then(async user=>{

      return await this.loginService.obtenerUsuarioConId(user.id).then( async echoedResult =>{
        let data = JSON.stringify(echoedResult);
        let array = JSON.parse(data);
        if(array[0]){
          // localStorage.setItem('currentUser', JSON.stringify(array[0]));
          this.setObject('currentUser',array[0]);
          this.currentUserSubject.next(array[0]);
        }
        return array[0];
      }).catch(err=> err );
    }).catch((err) => {
      if(err.message === "invalid username/password"){
        this.messagesService.viewMessageToastControllerError(messages.usuarioNoExistente);
      }else{
        this.messagesService.viewMessageToastControllerError(messages.problemasConexion);
      }
    });
  }

  async setObject(key,data){
    await Storage.set({
      key: key,
      value: JSON.stringify(data)
    })
  }

  async getObject(key){
    const ret = await Storage.get({key: key});
    return JSON.parse(ret.value);
  }

  async setItem(key,data){
    await Storage.set({
      key: key,
      value: data
    })
  }

  async getItem(key){
    const value = await Storage.get({key: key});
    return value;
  }

}
